module.exports = __webpack_public_path__ + "img/programme4.b4bc1c7f.png";